import { useEffect } from "react";

// Injects a JSON-LD <script> into <head>, keyed by id so it can be replaced/removed.
export default function useJsonLd(id, data) {
  useEffect(() => {
    if (!data) return;
    const elId = `jsonld-${id}`;
    let el = document.getElementById(elId);
    if (!el) {
      el = document.createElement("script");
      el.type = "application/ld+json";
      el.id = elId;
      document.head.appendChild(el);
    }
    el.textContent = JSON.stringify(data);
    return () => {
      const node = document.getElementById(elId);
      if (node) node.remove();
    };
  }, [id, JSON.stringify(data)]);
}
